import { Link } from 'react-router-dom';
import type { LinkProps } from 'react-router-dom';
import { Colors, Media, TextStylesDesktop, TextStylesMobile } from 'enums';
import styled from 'styled-components';

export const BackLinkIcon = styled.img`
  transform: rotate(270deg);
  width: 20px;
  height: 20px;
`;

export const BreadcrumbsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;

  @media ${Media.notebook} {
    gap: 8px;
  }
`;

export const BreadcrumbLink = styled(Link)<LinkProps & { $isActive?: boolean }>`
  color: ${({ $isActive }) => ($isActive ? Colors.gray1 : Colors.gray2)};
  text-decoration: none;
  line-height: 147%;

  ${TextStylesMobile.body}
  font-weight: 500;

  @media ${Media.notebook} {
    ${TextStylesDesktop.body}
    font-weight: 500;
  }

  &:hover {
    color: ${Colors.gray1};
  }
`;
